<!-- ============ SPLASH SCREEN ============ -->
<div class="global-splash-screen" *ngIf="!kossayaService.isInitialized">
    <div class="splash-content">
        <img src="assets/images/kossaya/logo_putih.png" alt="Kos Saya" class="splash-logo" />
        <div class="splash-spinner"></div>
    </div>
</div>

<div class="uh-page" [style.--theme-primary]="theme.primary"
     [style.--theme-dark]="theme.primaryDark"
     [style.--theme-light]="theme.primaryLight"
     [style.--theme-gradient]="theme.gradient"
     [style.--theme-card-bg]="theme.cardBg"
     [style.--theme-nav-active]="theme.navActive">

    <!-- ══════ Loading Skeleton ══════ -->
    <div class="uh-loading" *ngIf="loading">
        <div class="uh-loading__spinner"></div>
        <span>Memuat data...</span>
    </div>

    <div *ngIf="!loading">
        <!-- ══════ Hero Header ══════ -->
        <div class="uh-hero">
            <!-- Left accent strip (darker shade with room number) -->
            <div class="uh-hero__left-strip">
                <span class="uh-hero__room-number" [class.long]="roomLabel.length > 3">{{ roomLabel }}</span>
            </div>

            <!-- Main hero content area -->
            <div class="uh-hero__content">
                <!-- Watermark backdrop -->
                <img src="assets/images/kossaya/logo_backdrop.png" alt="" class="uh-hero__watermark" />

                <!-- BNB Mansion Logo -->
                <div class="uh-hero__logo-wrap">
                    <img src="assets/images/kossaya/bnb_mansion_logo.png" alt="BNB Luxury Mansion" class="uh-hero__logo" />
                </div>

                <!-- Occupant Name -->
                <div class="uh-hero__occupant">
                    <span class="uh-hero__occupant-name">{{ occupantName }}</span>
                </div>
            </div>
        </div>

        <!-- ══════ Child Page Content ══════ -->
        <router-outlet></router-outlet>

        <!-- ══════ Bottom Navigation ══════ -->
        <nav class="uh-bottom-nav">
            <button class="uh-bottom-nav__item"
                    [class.active]="activeNav === 'home'"
                    (click)="setActiveNav('home')">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
            </button>
            <button class="uh-bottom-nav__item"
                    [class.active]="activeNav === 'notifications'"
                    (click)="setActiveNav('notifications')">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                </svg>
            </button>
            <button class="uh-bottom-nav__item"
                    [class.active]="activeNav === 'info'"
                    (click)="setActiveNav('info')">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
            </button>
        </nav>
    </div>
</div>
